
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"},style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 512 512","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/","style":"fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"white","fill-rule":"nonzero"},attrs:{"d":"M173.898,439.404L7.498,273.004C-2.499,263.007 -2.499,246.798 7.498,236.8L43.701,200.596C53.698,190.598 69.908,190.598 79.905,200.596L192,312.69L432.095,72.596C442.092,62.599 458.302,62.599 468.299,72.596L504.502,108.8C514.499,118.797 514.499,135.006 504.502,145.004L210.102,439.405C200.104,449.402 183.895,449.402 173.898,439.404Z"}})])
          )
        }
      }
    